import { throwError } from "@/lib/throwError";
import { del, get, patch, post, put } from "@/services/axiosUitils";
import { PaginatedResponse } from "@/utils/types/tenantPermissions";
import { Translation } from "@/utils/types/translationHooks";

const base = "/api/tenant-core/translations/";

class TranslationService {
  listTranslations = async (
    page = 1,
    page_size = 10
  ): Promise<PaginatedResponse<Translation>> => {
    return await get(base, {
      params: { page, page_size },
    });
  };

  getTranslationById = async (id: string): Promise<Translation> => {
    if (!id) {
      throwError("ID is required", "TranslationService");
    }
    return await get(`${base}${id}/`);
  };

  createTranslation = async (
    payload: Partial<Translation>
  ): Promise<Translation> => {
    if (!payload) {
      throwError("Payload is required", "TranslationService");
    }
    return await post(base, payload);
  };

  putTranslation = async (
    id: string,
    data: Translation
  ): Promise<Translation> => {
    if (!id || !data) {
      throwError("ID and data are required", "TranslationService");
    }
    return await put(`${base}${id}/`, data);
  };

  updateTranslation = async (
    id: string,
    data: Partial<Translation>
  ): Promise<Translation> => {
    if (!id || !data) {
      throwError("ID and data are required", "TranslationService");
    }
    return await patch(`${base}${id}/`, data);
  };

  deleteTranslation = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "TranslationService");
    }
    return await del(`${base}${id}/`);
  };
}

export default new TranslationService();
